// removed by extract-text-webpack-plugin
module.exports = {"search-category-S":"search-category-S","search-input-group":"search-input-group","group-title":"group-title","group-input":"group-input","btn-search-category":"btn-search-category"};


//////////////////
// WEBPACK FOOTER
// ./components/category-detail/search-category/style.scss
// module id = ./components/category-detail/search-category/style.scss
// module chunks = 0